import { Injectable } from '@angular/core';
import { UserService } from '../services/user.service';
import { AuthenticationService } from '../services/authentication.service';
import { ApiService } from '../services/api.service';
import { User, APIResponse } from '../models';

@Injectable()
export class ProfilePictureService {
  private result = {
    data: '',
    error: '',
    success: false
  };

  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private authenticationService: AuthenticationService
  ) {
    this.result.data = null;
    this.result.error = null;
  }

  private _addImageInServer(formData: FormData) {
    // hit api endpoint using service here
    const self = this;
    // console.log(this.formData.get('image'), this.formData.get('imagedata'),this.formData.get('userid') this.result);
    this._uploadProfPic(formData).then(function(res) {
      self.authenticationService.load();
    });

    // after posting data, reset the value in formData to avoid duplicate file upload
    formData.delete('image');
    formData.delete('imagedata');

    this.result.data = null;
    this.result.error = null;
    this.result.success = true;
    return this.result;
  }

  private _uploadProfPic(data: FormData): Promise<APIResponse<string, any>> {
    return this.apiService.postPromise('/user/update/profilepicture', data);
  }

  // check file type (non images)
  private _checkFileType(name: string, type: string) {
    const fileType = this._checkImageType(type);

    if (fileType === 'else') {
      console.log(fileType);
      this.result.error = 'FileType Not Allowed (only .jpg, .png, .gif)';
      return 'not_allowed';
    } else {
      return fileType;
    }
  }

  // check file type (images)
  private _checkImageType(type: string): string {
    switch (type) {
      case 'image/png':
        return 'png';
      case 'image/gif':
        return 'gif';
      case 'image/jpeg':
        return 'jpg';
      default:
        return 'else';
    }
  }

  public pictureValidation(file: FileList, user: string) {
    let formData: FormData = new FormData();

    if (file !== null) {
      // if attachment exist, do attachments validation
      // do check filetype
      let type = this._checkFileType(file[0].name, file[0].type);

      // checking total attachment size
      if (file[0].size > 2048000) {
        this.result.error = 'Total files size must not exceed 2 MB';
        type = 'not_allowed';
        return this.result;
      }

      // if the files not meet the criteria, dont append
      if (type !== 'not_allowed') {
        const profpic = {
          filename: file[0].name,
          extension: type,
          filesize: file[0].size
        };

        // append each attachments to formData and append userid
        formData.append('image', file[0], file[0].name);
        formData.append('imagedata', JSON.stringify(profpic));
        formData.append('userid', user);

        // add attachment in server endpoint
        return this._addImageInServer(formData);
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/profile-picture.service.ts